export default __webpack_public_path__ + "static/media/Magical Strings 2018 (226 of 264) stage left at end.6cfa9279.jpg";